import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Card, message } from "antd";
import { useNavigate } from "react-router-dom";
import styles from "./Franchise.module.css";
// import useHttpForm from "../../hooks/useHttpForm";
import Cookies from "js-cookie";
import { BASE_URL } from "../../Apis/BaseUrl";
import TopNavbar from "../../Component/TopMenu/TopNavbar";
import NavbarSection from "../../Component/NavbarSection/NavbarSection";
import { Helmet } from "react-helmet";

const AddFranchise = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // const { sendRequest, isLoading } = useHttpForm();

  const [sellers, setSellers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchSellers = async () => {
      const res = await fetch(`${BASE_URL}/franchise/sellers`, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${
            (Cookies.get("v&b_token")
              ? JSON.parse(Cookies.get("v&b_token"))
              : null
            )?.token
          }`,
        },
      });
      const data = await res.json();
      console.log(data);
      setSellers(data);
    };
    fetchSellers();
  }, []);

  const onFinish = async (values) => {
    console.log(values);
    setIsLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/franchise/register`, {
        method: "POST",
        body: JSON.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            (Cookies.get("v&b_token")
              ? JSON.parse(Cookies.get("v&b_token"))
              : null
            )?.token
          }`,
        },
      });
      const data = await res.json();
      console.log(data);

      if (res.ok) {
        message.success("Franchise registration successful!");
        form.resetFields(); // Clear the form
        navigate("/franchise");
      } else {
        message.error(data.message || "Registration failed. Please try again.");
      }
    } catch (error) {
      message.error("An error occurred. Please try again later.");
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Add Franchise</title>
      </Helmet>
      <TopNavbar />
      <NavbarSection />

      {/* Hero Section Container */}
      <div style={{ padding: "30px 40px" }}>
        <div style={{ marginBottom: "30px", textAlign: "center" }}>
          <h6
            style={{
              color: "#AE0000",
              fontSize: "1.3rem",
              fontWeight: "600",
              margin: 0,
            }}
          >
            Add New Franchise
          </h6>
        </div>

        {/* Form Container */}
        <div
          style={{
            border: "1px solid #E0E1E0",
            borderRadius: "6px",
            padding: "30px",
            backgroundColor: "white",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              name="name"
              label={
                <span style={{ fontWeight: "500", color: "#333" }}>Name</span>
              }
              rules={[{ required: true, message: "Please input your name!" }]}
            >
              <Input
                placeholder="Enter your name"
                autoComplete="off"
                style={{
                  height: "40px",
                  borderRadius: "6px",
                  border: "1px solid #E0E1E0",
                }}
              />
            </Form.Item>

            <Form.Item
              name="email"
              label={
                <span style={{ fontWeight: "500", color: "#333" }}>Email</span>
              }
              rules={[
                { required: true, message: "Please input your email!" },
                { type: "email", message: "Please enter a valid email!" },
              ]}
            >
              <Input
                placeholder="Enter your email"
                autoComplete="off"
                style={{
                  height: "40px",
                  borderRadius: "6px",
                  border: "1px solid #E0E1E0",
                }}
              />
            </Form.Item>

            <Form.Item
              name="password"
              label={
                <span style={{ fontWeight: "500", color: "#333" }}>
                  Password
                </span>
              }
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password
                placeholder="Enter your password"
                autoComplete="new-password"
                style={{
                  height: "40px",
                  borderRadius: "6px",
                  border: "1px solid #E0E1E0",
                }}
              />
            </Form.Item>

            <Form.Item
              name="sellers"
              label={
                <span style={{ fontWeight: "500", color: "#333" }}>
                  Select Sellers
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "Please select at least one seller!",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select sellers"
                options={sellers.map((seller) => ({
                  value: seller.value,
                  label: seller.label,
                }))}
                optionFilterProp="label"
                showSearch
                allowClear
                style={{
                  borderRadius: "6px",
                }}
              />
            </Form.Item>

            <Form.Item style={{ marginTop: "30px" }}>
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-1 border-0"
                  style={{
                    backgroundColor: "#AE0000",
                    color: "white",
                    height: "45px",
                    flex: "1",
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? "Adding..." : "Add Franchise"}
                </button>
                <button
                  type="button"
                  className="px-4 py-2 rounded-1 border-0"
                  style={{
                    backgroundColor: "#6c757d",
                    color: "white",
                    height: "45px",
                    flex: "1",
                  }}
                  onClick={() => navigate("/franchise")}
                >
                  Cancel
                </button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AddFranchise;
